import { LogoAutomations, LogoText, LogoEmail, LogoActivity, LogoLink } from '_logo';

export const RoleName =
{
  SuperAdmin: 1,
  Admin: 2,
  Marketer: 3,
  Recruiter: 4,
  Client: 5,
  Candidate: 6,
  Employee: 7,
};

export const LoginStates = {
  Loading: 'loading',
  Login: 'login',
  SetupMfa: 'setupMfa',
  ConfirmMfa: 'confirmMfa',
};

export const MfaMethod = {
  Totp: 'Totp',
  Email: 'Email',
};

// ROI-48. The trigger preview's match count has four outcomes, and a nullable number cannot tell
// them apart: "not requested yet", "we have a number", "the backend gave up on a count this large",
// and "the request failed". The last two both render a dash, but they need different copy — telling
// someone their trigger "covers too many records" when the endpoint actually 500'd is confidently
// wrong, and hides a real fault behind a reassuring message.
export const TriggerMatchCountStatus = {
  Idle: 'idle',
  Ok: 'ok',
  Unavailable: 'unavailable',
  Error: 'error',
};

export const TextType = {
  Title: 1,
  Body: 2
};

export const CanvasNodeType =
{
  MultipleChoice: 0,
  FreeTextReply: 1,
  NoReply: 2,
  UserName: 3,
  EmailAddress: 4,
  PhoneNumber: 5,
  DocumentUpload: 6,
  NetPromoterScore: 7
};

export const ActionStep =
  [
    "Multiple Choice",
    "Free Text Reply",
    "No Reply",
    "User's Name",
    "Email Address",
    "Phone Number",
    "Document Upload",
    "Net Promoter Score",
  ];

export const Placeholder_FreeTextArea =
  [
    `Welcome aboard! We'd love to help you get started. What are looking to do first?`
    , 'What state do you live in ?'
    , 'Welcome we hope you find your visit today helpful!'
    , `What's your name ?`
    , `What's your email ?`
    , `What's the best number to reach you during the week ?`
    , `What state do you want to upload ? \n "Please upload your documents in MS Word or PDF format and ensure the file size is less than 5Mb. Alternatively, please include a link to your online documents."`
    , 'On a scale of zero to ten, how likely are you to recommend our business to a friend or colleague?'
  ];

export const UploadToS3Type = {
  Temporary: 0,
  Avatar: 1,
  Preview: 2,
  Attachment: 3,
  TemplateDesign: 4
};

export const CandidateColumnName = {
  CandidateName: 'Candidate Name',
  CurrentJobTitle: 'Current Job Title',
  CurrentEmployer: 'Current Employer',
  Location: 'Location',
  Resume: 'Resume',
  PhoneNumber: 'Phone Number',
  MobileNumber: 'Mobile Number',
  EmailAddress: 'Email Address',
  RoiAiScore: 'Roi-AI Score',
  RecruiterRating: 'Recruiter Rating',
  LastContacted: 'Last Contacted',
  RecentActivity: 'Recent Activity',
};

export const ClientColumnName = {
  ClientName: 'Contact Name',
  CurrentJobTitle: 'Job Title',
  Company: 'Company',
  PhoneNumber: 'Phone Number',
  MobileNumber: 'Mobile Number',
  EmailAddress: 'Email Address',
  RoiAiScore: 'Roi-AI Score',
};

export const CandidateColumnEnum = {
  CandidateName: 0,
  JobTitle: 1,
  CurrentEmployer: 2,
  Location: 3,
  PhoneNumber: 4,
  MobileNumber: 5,
  EmailAddress: 6,
  RoiAiScore: 7,
  Resume: 8,
  RecruiterRating: 9,
  LastContacted: 10,
  RecentActivity: 11,
};

export const ClientColumnEnum = {
  CandidateName: 0,
  JobTitle: 1,
  Organisation: 2,
  Location: 3,
  PhoneNumber: 4,
  EmailAddress: 5,
  RecruiterRating: 6,
  TotalJobPosted: 7,
  LastContacted: 8,
  RecentActivity: 9,
  RoiAiScore: 10,
  Industry: 11
};

export const JobColumnEnum = {
  JobTitle: 0,
  Organisation: 1,
  Status: 2,
  Location: 3,
  Source: 4,
  ClientName: 5,
  Industry: 6
};

export const JobCandidateColumnEnum = {
  CandidateName: 0,
  CandidateTitle: 1,
  Tactic: 2,
  Status: 3,
  RoiAiScore: 4,
  RecruiterRating: 5,
  Resume: 6,
  Type: 7
};

export const LeadColumnEnum = {
  LeadName: 0,
  JobTitle: 1,
  CurrentEmployer: 2,
  Industry: 3,
  Location: 4,
  PhoneNumber: 5,
  EmailAddress: 6,
  RecruiterRating: 7,
  LastContacted: 8,
  RecentActivity: 9,
  RoiAiScore: 10,
};

export const TabNameEnum = {
  Candidate: 1,
  Client: 2,
  Job: 3,
  Lead: 4,
  CandidateAudience: 5
};

export const storyType = {
  Website: 0,
  Registration: 1,
  DataCleanse: 2,
  Survey: 3,
  All: 4,
};

export const ValidationStatus = {
  Valid: 0,
  InvalidLength: 1,
  InvalidNumber: 2,
  InvalidEmail: 3,
};

export const ContactType = {
  Candidate: 1,
  Client: 2,
  Lead: 3
};

export const FinalizeWidgetPlacement = {
  BottomLeft: 0,
  BottomRight: 1
};

export const MonthList = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11
}

export const SortingFilter = {
  OldestToNewest: 1,
  NewestToOldest: 2,
  AZ: 3,
  ZA: 4
}

export const searchTypeFilter = {
  All: 0,
  Company: 1,
  User: 2
}

export const CandidateAudienceColumnEnum = {
  AudienceName: 0,
  AudienceType: 1,
  Status: 2,
  TotalMembers: 3,
  Source: 4,
  Created: 5,
  LastAddedDate: 6,
  LastActivityDate: 7,
  LastActivity: 8,
  ActionButton: 9
};

export const AudienceType = {
  Automatic: 1,
  Manual: 2
};

export const CampaignBlastMethod = {
  Default: 0,
  Email: 1,
  Text: 2,
  Whatsapp: 3,
  Form: 4,
  Survey: 6,
};

export const FeatureType = {
  Email: 1,
  Sms: 2,
  Whatsapp: 3,
  Form: 4,
  EmailLink: 5,
  Survey: 6,
  WebActivityTracker: 7,
  SMSLink: 8,
};

export const ActivityFeatureType = {
  1: {
    text: "Email",
    icon: LogoEmail
  },
  2: {
    text: "SMS",
    icon: LogoText
  },
  3: {
    text: "Whatsapp",
    icon: LogoText
  },
  4: {
    text: "Form",
    icon: LogoEmail
  },
  5: {
    text: "Email Link",
    icon: LogoLink
  },
  6: {
    text: "Survey",
    icon: LogoAutomations
  },
  7: {
    text: "Web activity tracking",
    icon: LogoActivity
  },
  8: {
    text: "SMS Link",
    icon: LogoLink
  },
};

export const LinkValidityType = {
  Minute: 0,
  Hour: 1,
  Day: 2
};

export const DelayTypeCandidate = {
  CandidateBased: 1
}

export const DelayTypeClient = {
  ClientBased: 1
}

export const DelayTypeNameCandidate = {
  CandidateBased: 'Candidate Based'
}

export const DelayTypeNameClient = {
  ClientBased: 'Contact Based'
}

export const TriggerType = {
  CandidateBased: 1,
  PlacementBased: 2,
  JobBased: 3
}

export const TriggerTypeClient = {
  ClientBased: 1,
  PlacementBased: 2,
  JobBased: 3,
}

export const TriggerTypeList = [
  {
    id: 1,
    name: "Candidate based"
  },
  {
    id: 2,
    name: "Placement based"
  },
  {
    id: 3,
    name: "Job based"
  }
]

export const LegacyTriggerTypeList = [
  {
    id: 1,
    name: "Candidate based"
  },
  {
    id: 2,
    name: "Placement based"
  }
]

export const TriggerTypeListClient = [
  {
    id: 1,
    name: "Contact based"
  },
  {
    id: 2,
    name: "Placement based"
  },
  {
    id: 3,
    name: "Job based"
  }
]

export const LegacyTriggerTypeListClient = [
  {
    id: 1,
    name: "Contact based"
  },
  {
    id: 2,
    name: "Placement based"
  }
]

export const TriggerList = {
  CandidateSubmitForm: 1,
  JobApplicationReceived: 2,
  JobApplicationRejection: 3,
  PlacementDateBased: 4,
  NurturePassiveCandidate: 5,
  ManualUpdateByUser: 6,
  CandidateStatusChanged: 7,
  RoiAiActivityScore: 8,
  CandidatePlacementStartDate: 9,
  UpdateResume: 10,
  CandidateNote: 11,
  RoiAiActivity: 12,
  CandidateCustomFieldList: 13,
  CandidateCustomFieldMultiSelectList: 14,
  CandidatePlacementEndDate: 15,
  CandidatePlacementCreatedDate: 16,
  EmailAddress: 17,
  MobileNumber: 18,
  Birthday: 19,
  Availability: 20,
  ApplicationStatus: 21,
  JobStatus: 22,
  JobJobApplicationReceived: 23,
  PlacementJobApplicationReceived: 24,
  InterviewDate: 25,
  DateCreated: 26,
  DateUpdated: 27,
  CandidateCountry: 28,
  SecondaryEmailAddress: 29,
  PhoneNumber: 30,
  SurveyScore: 31,
  CandidateSkills: 32,
  CandidateJobWorkType: 33,
  CandidateJobCategories: 34,
  CandidateJobTypes: 35,
  CandidateJobId: 36,
  CandidateJobLocation: 37,
  CandidateCurrentPosition: 38,
  CandidateCurrentEmployer: 39,
  CandidatePostalCode: 40,
  CandidateCity: 41,
  CandidateState: 42,
  CandidateRating: 43,
  DocumentExpiryDate: 44,
  PlacementDocumentExpiryDate: 45,
  JobDocumentExpiryDate: 46,
  FormScore: 47,
  JobFormScore: 48,
  PlacementFormScore: 49,
  CandidateCustomFieldDate: 50,
  CandidateUnsubscribe: 51,
  PlacementStatus: 52,
  PlacementType: 53,
  CandidateSource: 54,
  JobDateCreated: 55,
  JobDateUpdated: 56,
  CandidateNps: 57,
  PlacementCustomFieldList: 58,
  PlacementCustomFieldMultiSelectList: 59,
  ApplicationCustomFieldList: 60,
  ApplicationCustomFieldMultiSelectList: 61,
  JobCustomFieldList: 62,
  JobCustomFieldMultiSelectList: 63,
  CandidateDocumentType: 64,
  PlacementCustomFieldDate: 65,
  ApplicationCustomFieldDate: 66,
  JobCustomFieldDate: 67,
  CandidateContactMethod: 68,
  CandidateSeeking: 69,
  // ROI-356: Survey opened / Survey completed / Form completed on job-based and placement-based campaigns.
  // 68 and 69 are taken by ROI-293 (Contact method, Seeking).
  JobRoiAiActivity: 70,
  PlacementRoiAiActivity: 71,
};

export const PlacementTypeExclusions = {
  EndDate: ["credit", "permanent"]
};

export const TriggerListClient = {
  RoiAiActivity: 1,
  ClientPlacementStartDate: 2,
  ClientNote: 3,
  ClientStatus: 4,
  ClientPlacementCreatedDate: 5,
  ClientPlacementEndDate: 6,
  ClientCustomFieldList: 7,
  ClientCustomFieldMultiSelectList: 8,
  JobStatus: 9,
  ClientJobInterviewDate: 10,
  DateCreated: 11,
  DateUpdated: 12,
  RoiAiActivityScore: 13,
  SurveyScore: 14,
  ClientJobWorkType: 15,
  ClientJobCategories: 16,
  ClientJobTypes: 17,
  ClientJobId: 18,
  ClientJobLocation: 19,
  ClientPosition: 20,
  ClientCity: 21,
  ClientState: 22,
  ClientPostalCode: 23,
  ClientCountry: 24,
  ClientCompany: 25,
  FormScore: 26,
  ClientJobFormScore: 27,
  ClientPlacementFormScore: 28,
  ClientCustomFieldDate: 29,
  ClientUnsubscribe: 30,
  ClientPlacementStatus: 31,
  ClientPlacementType: 32,
  ClientJobDateCreated: 33,
  ClientJobDateUpdated: 34,
  ClientEmailAddress: 35,
  ClientSecondaryEmailAddress: 36,
  ClientPhoneNumber: 37,
  ClientMobileNumber: 38,
  ClientPlacementCustomFieldList: 39,
  ClientPlacementCustomFieldMultiSelectList: 40,
  ClientJobCustomFieldList: 41,
  ClientJobCustomFieldMultiSelectList: 42,
  ClientSkills: 43,
  ClientPlacementCustomFieldDate: 44,
  ClientJobCustomFieldDate: 45,
  ClientAggregateJobStatus: 46,
  ClientAggregatePlacementStatus: 47,
  // ROI-356: Survey opened / Survey completed / Form completed on contact job-based and placement-based campaigns.
  ClientJobRoiAiActivity: 48,
  ClientPlacementRoiAiActivity: 49,
  };

export const RoiAiActivityDetailsOption = {
  All: {
    Id: 0,
    Name: "All"
  },
  EmailIsDelivered: {
    Id: 6,
    Name: "Email is delivered"
  },
  EmailIsInvalid: {
    Id: 23,
    Name: "Email is invalid"
  },
  EmailIsBounced: {
    Id: 4,
    Name: "Email Bounced"
  },
  EmailUnsubscribe: {
    Id: 15,
    Name: "Email Unsubscribe"
  },
  EmailIsOpened: {
    Id: 5,
    Name: "Email Opened"
  },
  EmailLinkIsClicked: {
    Id: 17,
    Name: "Email link is clicked"
  },
  SMSIsSent: {
    Id: 7,
    Name: "SMS Sent"
  },
  SMSIsDelivered: {
    Id: 8,
    Name: "SMS Delivered"
  },
  SMSIsInvalid: {
    Id: 24,
    Name: "SMS Invalid"
  },
  TextUnsubscribe: {
    Id: 16,
    Name: "SMS Unsubscribe"
  },
  TextLinkIsClicked: {
    Id: 26,
    Name: "SMS Link Click"
  },
  SurveyIsOpened: {
    Id: 18,
    Name: "Survey Opened"
  },
  SurveyIsSubmited: {
    Id: 19,
    Name: "Survey Completed"
  },
  WebActivityTracker_PageView: {
    Id: 22,
    Name: "Web Activity - Page View"
  },
  WebActivityTracker_JobView: {
    Id: 20,
    Name: "Web Activity - Job View"
  },
  WebActivityTracker_ApplicationView: {
    Id: 21,
    Name: "Web Activity - Application View"
  },
  WebActivityTracker_CustomView: {
    Id: 25,
    Name: "Web Activity - Custom View"
  },
};

export const AutomationRoiActivityList = [
  // {
  //   id: 3,
  //   name: "Email is sent",
  //   type: CampaignBlastMethod.Email
  // },
  {
    //Add 'Any' into dropdown options #8372
    id: 0,
    name: "Any",
    type: CampaignBlastMethod.Email
  },
  {
    id: 6,
    name: "Email Delivered",
    type: CampaignBlastMethod.Email
  },
  {
    id: 23,
    name: "Email Invalid",
    type: CampaignBlastMethod.Email
  },
  {
    id: 4,
    name: "Email Bounced",
    type: CampaignBlastMethod.Email
  },
  {
    id: 15,
    name: "Email Unsubscribe",
    type: CampaignBlastMethod.Email
  },
  {
    id: 5,
    name: "Email Opened",
    type: CampaignBlastMethod.Email
  },
  {
    id: 17,
    name: "Email Link Click",
    linkType: FeatureType.EmailLink
  },
  {
    id: 29,
    name: "Form Completed",
    type: CampaignBlastMethod.Form
  },
  {
    id: 7,
    name: "SMS Sent",
    type: CampaignBlastMethod.Text
  },
  {
    id: 8,
    name: "SMS Delivered",
    type: CampaignBlastMethod.Text
  },
  {
    id: 24,
    name: "SMS Invalid",
    type: CampaignBlastMethod.Text
  },
  {
    id: 16,
    name: "SMS Unsubscribe",
    type: CampaignBlastMethod.Text
  },
  {
    id: 26,
    name: "SMS Link Clicked",
    linkType: FeatureType.SMSLink
  },
  {
    id: 18,
    name: "Survey Opened",
    type: CampaignBlastMethod.Survey
  },
  {
    id: 19,
    name: "Survey Completed",
    type: CampaignBlastMethod.Survey
  },
  {
    id: 22,
    name: "Web Activity - Page View"
  },
  {
    id: 20,
    name: "Web Activity - Job View"
  },
  {
    id: 21,
    name: "Web Activity - Application View"
  },
];

export const AutomationRoiActivityListClient = [
  // {
  //   id: 3,
  //   name: "Email is sent",
  //   type: CampaignBlastMethod.Email
  // },
  {
    //Add 'Any' into dropdown options #8372
    id: 0,
    name: "Any",
    type: CampaignBlastMethod.Email
  },
  {
    id: 6,
    name: "Email Delivered",
    type: CampaignBlastMethod.Email
  },
  {
    id: 23,
    name: "Email Invalid",
    type: CampaignBlastMethod.Email
  },
  {
    id: 4,
    name: "Email Bounced",
    type: CampaignBlastMethod.Email
  },
  {
    id: 15,
    name: "Email Unsubscribe",
    type: CampaignBlastMethod.Email
  },
  {
    id: 5,
    name: "Email Opened",
    type: CampaignBlastMethod.Email
  },
  {
    id: 17,
    name: "Email Link Click",
    linkType: FeatureType.EmailLink
  },
  {
    id: 18,
    name: "Survey Opened",
    type: CampaignBlastMethod.Survey
  },
  {
    id: 19,
    name: "Survey Completed",
    type: CampaignBlastMethod.Survey
  },
  {
    id: 22,
    name: "Web Activity - Page View"
  },
  {
    id: 25,
    name: "Web Activity - Custom View"
  },
  {
    id: 29,
    name: "Form Completed",
    type: CampaignBlastMethod.Form
  },
];

// ROI-356: Survey opened, Survey completed and Form completed are the only Activity options offered on
// job-based and placement-based campaigns. Survey and form data carry no job or placement id, so the
// back end matches the person and enters every job application, job or placement they have in the campaign.
export const SurveyFormActivityIds = [18, 19, 29];

const surveyFormActivityTrigger = (triggerId, activityOptions) => ({
  triggerId,
  customFieldTriggerId: null,
  triggerName: "Activity",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Is
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.IsNot
    },
  ],
  thirdColumn: {
    months: 0,
    weeks: 0,
    days: 1,
    hours: 0,
    activities: [],
    names: "",
    activityOptions: activityOptions.filter(x => SurveyFormActivityIds.includes(x.id)),
    subActivities: [],
    subActivityNames: "",
    hideTimeCondition: true,
  },
});

export const AutomationLoopingType = {
  ReEntryRestriction: 1,
  Looping: 2,
};

export const AutomationTimeOperator = {
  Equal: "Equals",
  AnyDate: "Any Date",
  LessThan: "Less Than",
  MoreThan: "More Than",
  Before: "Before",
  On: "On",
  After: "After",
  Has: "Has",
  HasNot: "Has Not",
  HasNo: "Has no",
  Is: "Is",
  IsNot: "Is Not",
  OnStartDate: "On Start Date", // for patching old data
  GreaterThan: "Greater Than",
  Exists: "Exists",
  IsEmpty: "Is Empty",
  DoesNotExist: "Does Not Exist",
  Contains: "Contains",
  NotContain: "Not Contain",
  StartsWith: "Starts With",
  IsDateEmpty: "Is Date Empty",
  DateExists: "Date Exists",
  Currently: "Currently",
  AnyTime: "Any Time"
};

// Shared operator option lists for the "aggregate" Job status / Placement status
// trigger and condition (ROI-64) - a single source of truth reused by their enum.js
// definitions and by every dropdown-restoration path in TriggerForm.js/IfElseForm.js,
// instead of retyping the same two arrays in each place.
export const AggregateStatusHasOperators = [
  { operatorId: 1, operatorName: AutomationTimeOperator.Has },
  { operatorId: 2, operatorName: AutomationTimeOperator.HasNo },
];

export const AggregateStatusTimeOperators = [
  { operatorId: 1, operatorName: AutomationTimeOperator.Currently },
  { operatorId: 2, operatorName: AutomationTimeOperator.LessThan },
  { operatorId: 3, operatorName: AutomationTimeOperator.MoreThan },
  { operatorId: 4, operatorName: AutomationTimeOperator.AnyTime },
];

// ROI-249: Birthday operators, shared by the trigger and the if-else condition so both dropdowns
// stay identical. Ids 1-3 are unchanged; 4 and 5 are Exists / Does Not Exist, and the back end
// uses the same two ids on TriggerConditionBeforeOnAfterExist (trigger) and
// TriggerCandidateDateOfBirthConditionType (condition).
export const BirthdayOperators = [
  { operatorId: 1, operatorName: AutomationTimeOperator.Before },
  { operatorId: 2, operatorName: AutomationTimeOperator.On },
  { operatorId: 3, operatorName: AutomationTimeOperator.After },
  { operatorId: 4, operatorName: AutomationTimeOperator.Exists },
  { operatorId: 5, operatorName: AutomationTimeOperator.DoesNotExist },
];

// Birthday operators that carry no time window, so the form must neither render the time inputs
// nor require them before the row counts as complete.
export const BirthdayOperatorsWithoutWindow = [
  AutomationTimeOperator.On,
  AutomationTimeOperator.Exists,
  AutomationTimeOperator.DoesNotExist,
];

export const AutomationTriggerListJobBased = [
  {
    triggerId: TriggerList.ApplicationStatus,
    customFieldTriggerId: null,
    triggerName: "Application status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      jobApplicationStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      jobApplicationStatusIds: [],
      jobApplicationStatusNames: "",
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.JobStatus,
    customFieldTriggerId: null,
    triggerName: "Job status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      jobStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      jobStatusIds: [],
      jobStatusNames: "",
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.InterviewDate,
    customFieldTriggerId: null,
    triggerName: "Interview Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
    ],
    thirdColumn: {
      options: [],
      interviews: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: TriggerList.JobJobApplicationReceived,
    customFieldTriggerId: null,
    triggerName: "Job application received",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      jobSources: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      jobIds: [],
      jobNames: "",
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.JobFormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.CandidateJobWorkType,
    customFieldTriggerId: null,
    triggerName: "Job Work Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      workTypes: [],
      workTypeIds: [],
      names: "",
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.CandidateJobCategories,
    customFieldTriggerId: null,
    triggerName: "Job Category",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      }
    ],
    thirdColumn: {
      keys: null,
      categories: [],
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateJobTypes,
    customFieldTriggerId: null,
    triggerName: "Job Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobTypes: [],
      jobTypeIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerList.CandidateJobId,
    customFieldTriggerId: null,
    triggerName: "Job IDs",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobs: [],
      candidateJobIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerList.CandidateJobLocation,
    customFieldTriggerId: null,
    triggerName: "Job Location",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobLocations: [],
      jobLocationIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerList.JobDocumentExpiryDate,
    customFieldTriggerId: null,
    triggerName: "Document Expiry Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.IsDateEmpty
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.DateExists
      }
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.Before
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.On
        },
        {
          operatorId: 4,
          operatorName: AutomationTimeOperator.After
        },
        {
          operatorId: 5,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 6,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      documentTypeOptions: [],
      documentTypes: [],
      names: "",
      operatorId: 2,
      operatorName: AutomationTimeOperator.Before,
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.JobDateCreated,
    customFieldTriggerId: null,
    triggerName: "Job Date created",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.JobDateUpdated,
    customFieldTriggerId: null,
    triggerName: "Job Date updated",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  surveyFormActivityTrigger(TriggerList.JobRoiAiActivity, AutomationRoiActivityList),
];

export const AutomationTriggerListJobBasedClient = [
  {
    triggerId: TriggerListClient.JobStatus,
    customFieldTriggerId: null,
    triggerName: "Job status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      jobStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      jobStatusIds: [],
      jobStatusNames: "",
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.ClientJobFormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.ClientJobInterviewDate,
    customFieldTriggerId: null,
    triggerName: "Interview Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
    ],
    thirdColumn: {
      options: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: TriggerListClient.ClientJobWorkType,
    customFieldTriggerId: null,
    triggerName: "Job Work Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      workTypes: [],
      workTypeIds: [],
      names: "",
      options: [],
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.ClientJobCategories,
    customFieldTriggerId: null,
    triggerName: "Job Category",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      }
    ],
    thirdColumn: {
      keys: null,
      categories: [],
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientJobTypes,
    customFieldTriggerId: null,
    triggerName: "Job Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobTypes: [],
      jobTypeIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerListClient.ClientJobId,
    customFieldTriggerId: null,
    triggerName: "Job IDs",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobs: [],
      clientJobIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerListClient.ClientJobLocation,
    customFieldTriggerId: null,
    triggerName: "Job Location",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobLocations: [],
      jobLocationIds: [],
      names: "",
    }
  },
  {
    triggerId: TriggerListClient.ClientJobDateCreated,
    customFieldTriggerId: null,
    triggerName: "Job Date created",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.ClientJobDateUpdated,
    customFieldTriggerId: null,
    triggerName: "Job Date updated",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  surveyFormActivityTrigger(TriggerListClient.ClientJobRoiAiActivity, AutomationRoiActivityListClient),
];

export const AutomationTriggerListPlacementBased = [
  {
    triggerId: 9,
    customFieldTriggerId: null,
    triggerName: "Start date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
      {
        operatorId: 7,
        operatorName: AutomationTimeOperator.GreaterThan
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: 15,
    customFieldTriggerId: null,
    triggerName: "End date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: 16,
    customFieldTriggerId: null,
    triggerName: "Created date",
    operators: [
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.AnyDate
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.PlacementDocumentExpiryDate,
    customFieldTriggerId: null,
    triggerName: "Document Expiry Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.IsDateEmpty
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.DateExists
      }
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.Before
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.On
        },
        {
          operatorId: 4,
          operatorName: AutomationTimeOperator.After
        },
        {
          operatorId: 5,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 6,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      documentTypeOptions: [],
      documentTypes: [],
      names: "",
      operatorId: 2,
      operatorName: AutomationTimeOperator.Before,
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.PlacementFormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators:[],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.PlacementStatus,
    customFieldTriggerId: null,
    triggerName: "Placement status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      placementStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      placementStatusIds: [],
      names: "",
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.PlacementType,
    customFieldTriggerId: null,
    triggerName: "Placement type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      placementTypes: [],
      placementTypeIds: [],
      names: "",
    }
  },
  surveyFormActivityTrigger(TriggerList.PlacementRoiAiActivity, AutomationRoiActivityList),
];

export const AutomationTriggerListClientPlacementBased = [
  {
    triggerId: 2,
    customFieldTriggerId: null,
    triggerName: "Start Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: 5,
    customFieldTriggerId: null,
    triggerName: "Created Date",
    operators: [
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.AnyDate
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: 6,
    customFieldTriggerId: null,
    triggerName: "End Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      options: [],
      placements: [],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: TriggerListClient.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.ClientPlacementFormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.ClientPlacementStatus,
    customFieldTriggerId: null,
    triggerName: "Placement status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      placementStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      placementStatusIds: [],
      names: "",
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.ClientPlacementType,
    customFieldTriggerId: null,
    triggerName: "Placement type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      placementTypes: [],
      placementTypeIds: [],
      names: "",
    }
  },
  surveyFormActivityTrigger(TriggerListClient.ClientPlacementRoiAiActivity, AutomationRoiActivityListClient),
];

export const AutomationTriggerCustomList = {
  triggerId: 0,
  customFieldTriggerId: 0,
  triggerName: "",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Is
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.IsNot
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.Exists
    },
    {
      operatorId: 4,
      operatorName: AutomationTimeOperator.IsEmpty
    },
  ],
  thirdColumn: {
    isMultiSelect: false,
    fieldId: 0,
    ids: [],
    names: "",
    options: [],
    customFieldValues: [],
    customFieldNames: "",
  }
};

export const AutomationTriggerCustomDateField = {
  triggerId: 0,
  customFieldTriggerId: 0,
  triggerName: "",
  operators: [
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.Before
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.On
    },
    {
      operatorId: 4,
      operatorName: AutomationTimeOperator.After
    },
    {
      operatorId: 5,
      operatorName: AutomationTimeOperator.LessThan
    },
    {
      operatorId: 6,
      operatorName: AutomationTimeOperator.MoreThan
    },
    {
      operatorId: 7,
      operatorName: AutomationTimeOperator.Exists
    },
    {
      operatorId: 8,
      operatorName: AutomationTimeOperator.IsEmpty
    },
  ],
  thirdColumn: {
    fieldId: 0,
    months: 0,
    weeks: 0,
    days: 1,
    hours: 0,
    hideTimeCondition: true,
  }
};

export const AutomationIfElseCustomList = {
  ifElseFirstColumnId: 0,
  customFieldIfElseId: 0,
  ifElseFirstColumnName: "",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Is
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.IsNot
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.Exists
    },
    {
      operatorId: 4,
      operatorName: AutomationTimeOperator.IsEmpty
    },
  ],
  thirdColumn: {
    isMultiSelect: false,
    fieldId: 0,
    ids: [],
    names: "",
    options: [],
    customFieldValues: [],
    customFieldNames: "",
  }
};

export const AutomationIfElseCustomDateField = {
  ifElseFirstColumnId: 0,
  customFieldIfElseId: 0,
  ifElseFirstColumnName: "",
  operators: [
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.Before
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.On
    },
    {
      operatorId: 4,
      operatorName: AutomationTimeOperator.After
    },
    {
      operatorId: 5,
      operatorName: AutomationTimeOperator.LessThan
    },
    {
      operatorId: 6,
      operatorName: AutomationTimeOperator.MoreThan
    },
    {
      operatorId: 7,
      operatorName: AutomationTimeOperator.Exists
    },
    {
      operatorId: 8,
      operatorName: AutomationTimeOperator.IsEmpty
    },
  ],
  thirdColumn: {
    fieldId: 0,
    months: 0,
    weeks: 0,
    days: 1,
    hours: 0,
    hideTimeCondition: true,
  }
};

export const StatusTimeDefaultVersion = 2;

export const AutomationTriggerList = [
  {
    triggerId: 12,
    customFieldTriggerId: null,
    triggerName: "Activity",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      activities: [],
      names: "",
      activityOptions: AutomationRoiActivityList,
      subActivities: [],
      subActivityNames: "",
      hideTimeCondition: true,
    },
  },
  {
    triggerId: 8,
    customFieldTriggerId: null,
    triggerName: "Roi score",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Equal
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      score: 0
    }
  },
  {
    triggerId: TriggerList.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerList.FormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: 7,
    customFieldTriggerId: null,
    triggerName: "Status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      candidateStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      ids: [],
      names: "",
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
      timeDefaultVersion: StatusTimeDefaultVersion,
    }
  },
  {
    triggerId: 11,
    customFieldTriggerId: null,
    triggerName: "Notes",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Has
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.HasNot
      },
    ],
    thirdColumn: {
      noteTypes: [],
      displayNoteTypes: "",
      options: [],
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.DateCreated,
    customFieldTriggerId: null,
    triggerName: "Date created",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.MoreThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.DateUpdated,
    customFieldTriggerId: null,
    triggerName: "Date updated",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.MoreThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: 2,
    customFieldTriggerId: null,
    triggerName: "Job application date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      jobSources: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      jobIds: [],
      jobNames: "",
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: 10,
    customFieldTriggerId: null,
    triggerName: "Resume date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.MoreThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.PhoneNumber,
    customFieldTriggerId: null,
    triggerName: "Phone",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerList.MobileNumber,
    customFieldTriggerId: null,
    triggerName: "Mobile",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerList.EmailAddress,
    customFieldTriggerId: null,
    triggerName: "Email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      emails: [],
      names: ""
    }
  },
  {
    triggerId: TriggerList.SecondaryEmailAddress,
    customFieldTriggerId: null,
    triggerName: "Secondary email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      secondaryEmails: [],
      names: ""
    }
  },
  {
    triggerId: TriggerList.Availability,
    customFieldTriggerId: null,
    triggerName: "Availability",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Before
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.On
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.After
      },
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerList.CandidateCountry,
    customFieldTriggerId: null,
    triggerName: "Country",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {
      countries: [],
      names: "",
      options: []
    }
  },
  {
    triggerId: TriggerList.Birthday,
    customFieldTriggerId: null,
    triggerName: "Birthday",
    operators: BirthdayOperators,
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    triggerId: TriggerList.CandidateSkills,
    customFieldTriggerId: null,
    triggerName: "Skills",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      keys: null,
      skills: [],
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateCurrentPosition,
    customFieldTriggerId: null,
    triggerName: "Current Position",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      currentPositionOptions: [],
      currentPositions: [],
      currentPosition: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateCurrentEmployer,
    customFieldTriggerId: null,
    triggerName: "Current Employer",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      currentEmployerOptions: [],
      currentEmployers: [],
      currentEmployer: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidatePostalCode,
    customFieldTriggerId: null,
    triggerName: "Postal Code",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
      {
        operatorId: 7,
        operatorName: AutomationTimeOperator.StartsWith
      },
    ],
    thirdColumn: {
      postalCodeOptions: [],
      postalCodes: [],
      postalCode: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateCity,
    customFieldTriggerId: null,
    triggerName: "City",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      cityOptions: [],
      cities: [],
      city: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateState,
    customFieldTriggerId: null,
    triggerName: "State",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      stateOptions: [],
      states: [],
      state: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.DocumentExpiryDate,
    customFieldTriggerId: null,
    triggerName: "Document Expiry Date",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.IsDateEmpty
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.DateExists
      },
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.Before
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.On
        },
        {
          operatorId: 4,
          operatorName: AutomationTimeOperator.After
        },
        {
          operatorId: 5,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 6,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      documentTypeOptions: [],
      documentTypes: [],
      names: "",
      operatorId: 2,
      operatorName: AutomationTimeOperator.Before,
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerList.CandidateDocumentType,
    customFieldTriggerId: null,
    triggerName: "Document Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.DoesNotExist
      },
    ],
    thirdColumn: {
      documentTypeOptions: [],
      documentType: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateRating,
    customFieldTriggerId: null,
    triggerName: "Rating",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {
      ratingOptions: [],
      ratings: [],
      rating: "",
      names: ""
    }
  },
  {
    triggerId: 51,
    customFieldTriggerId: null,
    triggerName: "Unsubscribed",
    isProviderLabel: true,
    operators: [
      { operatorId: 1, operatorName: "Yes" },
      { operatorId: 2, operatorName: "No" },
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerList.CandidateNps,
    customFieldTriggerId: null,
    triggerName: "Net promoter score",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Equal
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      score: null,
    }
  },
  {
    triggerId: TriggerList.CandidateSource,
    customFieldTriggerId: null,
    triggerName: "Source",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      sourceOptions: [],
      sources: [],
      source: "",
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateContactMethod,
    customFieldTriggerId: null,
    triggerName: "Contact method",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      contactMethods: [],
      names: ""
    }
  },
  {
    triggerId: TriggerList.CandidateSeeking,
    customFieldTriggerId: null,
    triggerName: "Seeking",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      seekingStatuses: [],
      names: ""
    }
  },
];

export const SeekingOptions = ["Yes", "Maybe", "No"];

export const LastAutomationTriggerCandidateId = AutomationTriggerList[AutomationTriggerList.length - 1].triggerId;

export const AutomationTriggerListClient = [
  {
    triggerId: 1,
    customFieldTriggerId: null,
    triggerName: "Activity",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      activities: [],
      names: "",
      activityOptions: AutomationRoiActivityListClient,
      subActivities: [],
      subActivityNames: "",
      hideTimeCondition: true,
    },
  },
  {
    triggerId: TriggerListClient.SurveyScore,
    customFieldTriggerId: null,
    triggerName: "Survey score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: TriggerListClient.FormScore,
    customFieldTriggerId: null,
    triggerName: "Form score",
    operators: [

    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    triggerId: 4,
    customFieldTriggerId: null,
    triggerName: "Status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      ids: [],
      names: "",
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      candidateStatuses: [],
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
      timeDefaultVersion: StatusTimeDefaultVersion,
    }
  },
  {
    triggerId: 3,
    customFieldTriggerId: null,
    triggerName: "Notes",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Has
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.HasNot
      },
    ],
    thirdColumn: {
      noteTypes: [],
      displayNoteTypes: "",
      options: [],
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.DateCreated,
    customFieldTriggerId: null,
    triggerName: "Date created",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.MoreThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.DateUpdated,
    customFieldTriggerId: null,
    triggerName: "Date updated",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.MoreThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    triggerId: TriggerListClient.RoiAiActivityScore,
    customFieldTriggerId: null,
    triggerName: "Roi score",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Equal
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      score: 0
    }
  },
  {
    triggerId: TriggerListClient.ClientPosition,
    customFieldTriggerId: null,
    triggerName: "Position",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientPositionOptions: [],
      clientPositions: [],
      clientPosition: "",
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientCity,
    customFieldTriggerId: null,
    triggerName: "City",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCityOptions: [],
      clientCities: [],
      clientCity: "",
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientState,
    customFieldTriggerId: null,
    triggerName: "State",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientStateOptions: [],
      clientStates: [],
      clientState: "",
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientPostalCode,
    customFieldTriggerId: null,
    triggerName: "Postal Code",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
      {
        operatorId: 7,
        operatorName: AutomationTimeOperator.StartsWith
      },
    ],
    thirdColumn: {
      clientPostalCodeOptions: [],
      clientPostalCodes: [],
      clientPostalCode: "",
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientCountry,
    customFieldTriggerId: null,
    triggerName: "Country",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCountryOptions: [],
      clientCountries: [],
      clientCountry: "",
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientCompany,
    customFieldTriggerId: null,
    triggerName: "Company",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCompanyOptions: [],
      clientCompanies: [],
      clientCompany: "",
      names: ""
    }
  },
  {
    triggerId: 30,
    customFieldTriggerId: null,
    triggerName: "Unsubscribed",
    isProviderLabel: true,
    operators: [
      { operatorId: 1, operatorName: "Yes" },
      { operatorId: 2, operatorName: "No" },
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerListClient.ClientAggregateJobStatus,
    customFieldTriggerId: null,
    triggerName: "Job status",
    operators: [...AggregateStatusHasOperators],
    thirdColumn: {
      options: [...AggregateStatusTimeOperators],
      jobStatuses: [],
      operatorId: 1,
      operatorName: AutomationTimeOperator.Currently,
      jobStatusIds: [],
      names: "",
      isActivityAllSelected: false,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      // Required by the backend contract (ThirdColumn.HideTimeCondition) even though
      // no frontend code reads it back - this trigger has no collapse-the-time-block
      // toggle, so the time block is never hidden and this must always stay false.
      hideTimeCondition: false,
    }
  },
  {
    triggerId: TriggerListClient.ClientEmailAddress,
    customFieldTriggerId: null,
    triggerName: "Contact Email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientEmails: [],
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientSecondaryEmailAddress,
    customFieldTriggerId: null,
    triggerName: "Contact Other email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientSecondaryEmails: [],
      names: ""
    }
  },
  {
    triggerId: TriggerListClient.ClientPhoneNumber,
    customFieldTriggerId: null,
    triggerName: "Contact Phone",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerListClient.ClientMobileNumber,
    customFieldTriggerId: null,
    triggerName: "Contact Mobile",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    triggerId: TriggerListClient.ClientSkills,
    customFieldTriggerId: null,
    triggerName: "Skills",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      keys: null,
      skills: [],
      names: ""
    },
  },
  {
    triggerId: TriggerListClient.ClientAggregatePlacementStatus,
    customFieldTriggerId: null,
    triggerName: "Placement status",
    operators: [...AggregateStatusHasOperators],
    thirdColumn: {
      options: [...AggregateStatusTimeOperators],
      placementStatuses: [],
      operatorId: 1,
      operatorName: AutomationTimeOperator.Currently,
      placementStatusIds: [],
      names: "",
      isActivityAllSelected: false,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      // See the ClientAggregateJobStatus entry above - required by the backend
      // contract, always false since this trigger has no collapse toggle.
      hideTimeCondition: false,
    }
  },
];

export const AutomationDelayFirstColumnType = {
  RoiAiActivity: {
    Id: 1,
    Name: "Activity",
  },
};

export const AutomationDelayFirstColumnTypeClient = {
  RoiAiActivity: {
    Id: 1,
    Name: "Activity",
  },
};

export const AutomationIfElseFirstColumnType = {
  RoiAiActivity: 1,
  CandidateNote: 2,
  CandidateStatus: 3,
  NetPromoterScore: 4,
  Birthday: 5,
  ApplicationStatus: 6,
  DateCreated: 7,
  DateUpdated: 8,
  PlacementStatus: 9,
  SurveyScore: 10,
  CandidateSkills: 12,
  CandidateJobWorkType: 13,
  CandidateJobCategories: 14,
  CandidateJobTypes: 15,
  CandidateJobLocation: 16,
  CandidateJobId: 17,
  CandidateCurrentPosition: 18,
  CandidateCurrentEmployer: 19,
  CandidatePostalCode: 20,
  CandidateCity: 21,
  CandidateState: 22,
  CandidateRating: 23,
  FormScore: 24,
  CandidateCustomFieldList: 25,
  CandidateCustomFieldMultiSelectList: 26,
  CandidateCustomFieldDate: 27,
  CandidateUnsubscribe: 28,
  CandidateSource: 29,
  PlacementType: 30,
  // These values must match the backend's ActivityType enum exactly (not just be unique on the FE) -
  // condition steps send ifElseFirstColumnId straight through with no remapping. Unlike the Client
  // enum below, backend groups all List/MultiSelectList/Date values contiguously per entity (31-39)
  // and reserves Text/Url for all three entities together afterwards (40-45), rather than gapping
  // each entity's own Text/Url slots inline.
  PlacementCustomFieldList: 31,
  PlacementCustomFieldMultiSelectList: 32,
  PlacementCustomFieldDate: 33,
  ApplicationCustomFieldList: 34,
  ApplicationCustomFieldMultiSelectList: 35,
  ApplicationCustomFieldDate: 36,
  JobCustomFieldList: 37,
  JobCustomFieldMultiSelectList: 38,
  JobCustomFieldDate: 39,
  // 40-41 = Placement Text/Url, 42-43 = Application Text/Url, 44-45 = Job Text/Url
  // (backend-reserved, not used here)
  CandidateCountry: 46,
  JobDateCreated: 47,
  JobDateUpdated: 48,
  CandidateEmail: 49,
  CandidateOtherEmail: 50,
  CandidatePhone: 51,
  CandidateMobile: 52,
  CandidateDocumentType: 53,
  CandidateContactMethod: 54,
  CandidateSeeking: 55,
  // ROI-355: must match ROI-BE ActivityType.CandidateRoiScore.
  RoiScore: 56,
  // ROI-368: must match ROI-BE ActivityType 57 to 60.
  CandidateAvailability: 57,
  CandidateJobApplicationDate: 58,
  CandidateResumeDate: 59,
  CandidateDocumentExpiryDate: 60,
  // ROI-358: must match ROI-BE ActivityType.CandidateJobStatus / CandidateJobInterviewDate.
  // Next free id: 63.
  CandidateJobStatus: 61,
  CandidateJobInterviewDate: 62,
};

export const AutomationIfElseFirstColumnTypeClient = {
  RoiAiActivity: 1,
  ClientStatus: 2,
  ClientNote: 3,
  DateCreated: 4,
  DateUpdated: 5,
  PlacementStatus: 6,
  SurveyScore: 11,
  ClientJobWorkType: 12,
  ClientJobCategories: 13,
  ClientJobTypes: 14,
  ClientJobLocation: 15,
  ClientJobId: 16,
  ClientPosition: 17,
  ClientCity: 18,
  ClientState: 19,
  ClientPostalCode: 20,
  ClientCountry: 21,
  ClientCompany: 22,
  FormScore: 23,
  ClientCustomFieldList: 24,
  ClientCustomFieldMultiSelectList: 25,
  ClientCustomFieldDate: 26,
  ClientUnsubscribe: 27,
  PlacementType: 28,
  // These values must match the backend's ClientActivityType enum exactly (not just be unique on the
  // FE) - condition steps send ifElseFirstColumnId straight through in ConvertToArrayStructure() with no
  // remapping. Backend reserves 5 slots per entity (List/MultiSelectList/Date/Text/Url); Text and Url are
  // never selectable here (filtered out upstream) but the values are left gapped so a future addition
  // doesn't silently collide with a different backend field type again.
  ClientPlacementCustomFieldList: 29,
  ClientPlacementCustomFieldMultiSelectList: 30,
  ClientPlacementCustomFieldDate: 31,
  // 32 = PlacementCustomFieldText, 33 = PlacementCustomFieldUrl (backend-reserved, not used here)
  ClientJobCustomFieldList: 34,
  ClientJobCustomFieldMultiSelectList: 35,
  ClientJobCustomFieldDate: 36,
  // 37 = JobCustomFieldText, 38 = JobCustomFieldUrl (backend-reserved, not used here)
  ClientEmail: 41,
  ClientOtherEmail: 42,
  ClientPhone: 43,
  ClientMobile: 44,
  ClientJobDateCreated: 39,
  ClientJobDateUpdated: 40,
  ClientSkills: 45,
  ClientAggregateJobStatus: 46,
  ClientAggregatePlacementStatus: 47,
  // ROI-355: must match ROI-BE ClientActivityType.ClientRoiScore.
  RoiScore: 48,
  // ROI-358: must match ROI-BE ClientActivityType.ClientJobStatus / ClientJobInterviewDate.
  // Next free id: 51.
  ClientJobStatus: 49,
  ClientJobInterviewDate: 50,
};

// ROI-355: Roi score condition, the same operators and value as the Roi score trigger (whole
// number 1 to 100, strict comparison). The name must stay "Roi score": conditionGroups.js finds
// the item by this name to show it as live in the Engagement group.
const roiScoreCondition = (ifElseFirstColumnId) => ({
  ifElseFirstColumnId,
  ifElseFirstColumnName: "Roi score",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Equal
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.LessThan
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.MoreThan
    },
  ],
  thirdColumn: {
    score: null,
  }
});

// ROI-358: per-job Job status condition, offered on Contact Jobs and Candidate Jobs only. It copies
// the Job status trigger of its side (TriggerList.JobStatus / TriggerListClient.JobStatus): same
// operators, same thirdColumn fields and the same validation. One agreed difference: a new row
// starts with the time block shown at Any Date (the trigger starts hidden at Less Than 1 hour), and
// hiding the block resets it to this default. The name must stay "Job status".
const jobStatusCondition = (ifElseFirstColumnId) => ({
  ifElseFirstColumnId,
  ifElseFirstColumnName: "Job status",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Is
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.IsNot
    },
  ],
  thirdColumn: {
    options: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.AnyDate
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    jobStatusIds: [],
    jobStatusNames: "",
    isActivityAllSelected: false,
    operatorId: 1,
    operatorName: AutomationTimeOperator.AnyDate,
    months: 0,
    weeks: 0,
    days: 0,
    hours: 0,
    hideTimeCondition: false,
  }
});

// ROI-358: Interview date condition, offered on Contact Jobs and Candidate Jobs only. It copies the
// Interview date trigger of its side: Before / On / After on an exact day, weeks and days. The
// candidate side also picks interview types (thirdColumn.interviews, required), as the candidate
// trigger does; the contact trigger has no type choice (External only), so neither has the contact
// condition. The name must stay "Interview date".
const interviewDateCondition = (ifElseFirstColumnId, withInterviewTypes) => ({
  ifElseFirstColumnId,
  ifElseFirstColumnName: "Interview date",
  operators: [
    {
      operatorId: 1,
      operatorName: AutomationTimeOperator.Before
    },
    {
      operatorId: 2,
      operatorName: AutomationTimeOperator.On
    },
    {
      operatorId: 3,
      operatorName: AutomationTimeOperator.After
    },
  ],
  thirdColumn: {
    ...(withInterviewTypes ? { interviews: [] } : {}),
    weeks: 0,
    days: 0,
  }
});


export const AutomationIfElseFirstColumnClient = [
  {
    ifElseFirstColumnId: 1,
    ifElseFirstColumnName: "Activity",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      activities: [],
      names: "",
      activityOptions: AutomationRoiActivityListClient,
      subActivities: [],
      subActivityNames: ""
    }
  },
  {
    ifElseFirstColumnId: 2,
    ifElseFirstColumnName: "Status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      timeOptions: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      contactStatuses: [],
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      ids: [],
      names: "",
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: 3,
    ifElseFirstColumnName: "Notes",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Has
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.HasNot
      },
    ],
    thirdColumn: {
      noteTypes: [],
      displayNoteTypes: "",
      options: []
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.DateCreated,
    ifElseFirstColumnName: "Date created",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.DateUpdated,
    ifElseFirstColumnName: "Date updated",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.PlacementStatus,
    ifElseFirstColumnName: "Placement status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      ids: [],
      names: "",
      timeOptions: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.PlacementType,
    ifElseFirstColumnName: "Placement type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      ids: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.SurveyScore,
    ifElseFirstColumnName: "Survey score",
    operators: [],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  roiScoreCondition(AutomationIfElseFirstColumnTypeClient.RoiScore),
  jobStatusCondition(AutomationIfElseFirstColumnTypeClient.ClientJobStatus),
  interviewDateCondition(AutomationIfElseFirstColumnTypeClient.ClientJobInterviewDate, false),
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.FormScore,
    ifElseFirstColumnName: "Form score",
    operators: [],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobWorkType,
    ifElseFirstColumnName: "Job Work Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      workTypes: [],
      workTypeIds: [],
      names: "",
      isActivityAllSelected: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobCategories,
    ifElseFirstColumnName: "Job Category",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      }
    ],
    thirdColumn: {
      keys: null,
      categories: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobTypes,
    ifElseFirstColumnName: "Job Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobTypes: [],
      jobTypeIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobId,
    ifElseFirstColumnName: "Job IDs",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobs: [],
      clientJobIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobLocation,
    ifElseFirstColumnName: "Job Location",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobLocations: [],
      jobLocationIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientPosition,
    ifElseFirstColumnName: "Position",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientPositionOptions: [],
      clientPositions: [],
      clientPosition: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientCity,
    ifElseFirstColumnName: "City",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCityOptions: [],
      clientCities: [],
      clientCity: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientState,
    ifElseFirstColumnName: "State",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientStateOptions: [],
      clientStates: [],
      clientState: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientPostalCode,
    ifElseFirstColumnName: "Postal Code",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
      {
        operatorId: 7,
        operatorName: AutomationTimeOperator.StartsWith
      },
    ],
    thirdColumn: {
      clientPostalCodeOptions: [],
      clientPostalCodes: [],
      clientPostalCode: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientCountry,
    ifElseFirstColumnName: "Country",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCountryOptions: [],
      clientCountries: [],
      clientCountry: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientCompany,
    ifElseFirstColumnName: "Company",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientCompanyOptions: [],
      clientCompanies: [],
      clientCompany: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: 27,
    ifElseFirstColumnName: "Unsubscribed",
    isProviderLabel: true,
    operators: [
      { operatorId: 1, operatorName: "Yes" },
      { operatorId: 2, operatorName: "No" },
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientEmail,
    ifElseFirstColumnName: "Contact Email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientEmails: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientOtherEmail,
    ifElseFirstColumnName: "Contact Other email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      clientSecondaryEmails: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientPhone,
    ifElseFirstColumnName: "Contact Phone",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientMobile,
    ifElseFirstColumnName: "Contact Mobile",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobDateCreated,
    ifElseFirstColumnName: "Job Date created",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientJobDateUpdated,
    ifElseFirstColumnName: "Job Date updated",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientAggregateJobStatus,
    ifElseFirstColumnName: "Job status",
    operators: [...AggregateStatusHasOperators],
    thirdColumn: {
      options: [],
      jobStatusIds: [],
      names: "",
      timeOptions: [...AggregateStatusTimeOperators],
      operatorId: 1,
      operatorName: AutomationTimeOperator.Currently,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      // Required by the backend contract (ThirdColumn.HideTimeCondition) even though
      // no frontend code reads it back - this condition has no collapse-the-time-block
      // toggle, so the time block is never hidden and this must always stay false.
      hideTimeCondition: false,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientSkills,
    ifElseFirstColumnName: "Skills",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      keys: null,
      skills: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnTypeClient.ClientAggregatePlacementStatus,
    ifElseFirstColumnName: "Placement status",
    operators: [...AggregateStatusHasOperators],
    thirdColumn: {
      options: [],
      placementStatusIds: [],
      names: "",
      timeOptions: [...AggregateStatusTimeOperators],
      operatorId: 1,
      operatorName: AutomationTimeOperator.Currently,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      // See the ClientAggregateJobStatus entry above - required by the backend
      // contract, always false since this condition has no collapse toggle.
      hideTimeCondition: false,
    }
  }
];

export const AutomationIfElseFirstColumn = [
  {
    ifElseFirstColumnId: 1,
    ifElseFirstColumnName: "Activity",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      activities: [],
      names: "",
      activityOptions: AutomationRoiActivityList.filter((value, index, arr) => {
        //#5281 only show Email is Invalid (23) and Text is Invalid (24) for Trigger
        return value.id !== 15 && value.id !== 16 && value.id !== 23 && value.id !== 24;
      }),
      subActivities: [],
      subActivityNames: ""
    }
  },
  {
    ifElseFirstColumnId: 3,
    ifElseFirstColumnName: "Status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      timeOptions: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      ids: [],
      names: "",
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 1,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.ApplicationStatus,
    ifElseFirstColumnName: "Application Status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      }
    ],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: 2,
    ifElseFirstColumnName: "Notes",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Has
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.HasNot
      },
    ],
    thirdColumn: {
      noteTypes: [],
      displayNoteTypes: "",
      options: []
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.DateCreated,
    ifElseFirstColumnName: "Date created",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.DateUpdated,
    ifElseFirstColumnName: "Date updated",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: 5,
    ifElseFirstColumnName: "Birthday",
    operators: BirthdayOperators,
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: 4,
    ifElseFirstColumnName: "Net promoter score",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Equal
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.LessThan
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.MoreThan
      },
    ],
    thirdColumn: {
      score: null,
    }
  },
  roiScoreCondition(AutomationIfElseFirstColumnType.RoiScore),
  jobStatusCondition(AutomationIfElseFirstColumnType.CandidateJobStatus),
  interviewDateCondition(AutomationIfElseFirstColumnType.CandidateJobInterviewDate, true),
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.PlacementStatus,
    ifElseFirstColumnName: "Placement status",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      ids: [],
      names: "",
      timeOptions: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.AnyDate
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        },
      ],
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.PlacementType,
    ifElseFirstColumnName: "Placement type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      options: [],
      ids: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.SurveyScore,
    ifElseFirstColumnName: "Survey score",
    operators: [],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      surveyList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.FormScore,
    ifElseFirstColumnName: "Form score",
    operators: [],
    thirdColumn: {
      options: [
        {
          operatorId: 1,
          operatorName: AutomationTimeOperator.Equal
        },
        {
          operatorId: 2,
          operatorName: AutomationTimeOperator.LessThan
        },
        {
          operatorId: 3,
          operatorName: AutomationTimeOperator.MoreThan
        }
      ],
      formList: [],
      ids: [],
      score: 0,
      isActivityAllSelected: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateSkills,
    ifElseFirstColumnName: "Skills",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      keys: null,
      skills: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobWorkType,
    ifElseFirstColumnName: "Job Work Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      workTypes: [],
      workTypeIds: [],
      names: "",
      isActivityAllSelected: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobCategories,
    ifElseFirstColumnName: "Job Category",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      }
    ],
    thirdColumn: {
      keys: null,
      categories: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobTypes,
    ifElseFirstColumnName: "Job Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobTypes: [],
      jobTypeIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobId,
    ifElseFirstColumnName: "Job IDs",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobs: [],
      candidateJobIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobLocation,
    ifElseFirstColumnName: "Job Location",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
    ],
    thirdColumn: {
      jobLocations: [],
      jobLocationIds: [],
      names: "",
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateCurrentPosition,
    ifElseFirstColumnName: "Current Position",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      currentPositionOptions: [],
      currentPositions: [],
      currentPosition: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateCurrentEmployer,
    ifElseFirstColumnName: "Current Employer",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      currentEmployerOptions: [],
      currentEmployers: [],
      currentEmployer: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateSource,
    ifElseFirstColumnName: "Source",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      sourceOptions: [],
      sources: [],
      source: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidatePostalCode,
    ifElseFirstColumnName: "Postal Code",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
      {
        operatorId: 7,
        operatorName: AutomationTimeOperator.StartsWith
      },
    ],
    thirdColumn: {
      postalCodeOptions: [],
      postalCodes: [],
      postalCode: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateCity,
    ifElseFirstColumnName: "City",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      cityOptions: [],
      cities: [],
      city: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateState,
    ifElseFirstColumnName: "State",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      stateOptions: [],
      states: [],
      state: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateRating,
    ifElseFirstColumnName: "Rating",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {
      ratingOptions: [],
      ratings: [],
      rating: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: 28,
    ifElseFirstColumnName: "Unsubscribed",
    isProviderLabel: true,
    operators: [
      { operatorId: 1, operatorName: "Yes" },
      { operatorId: 2, operatorName: "No" },
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateCountry,
    ifElseFirstColumnName: "Country",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 5,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 6,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      countryOptions: [],
      countries: [],
      country: "",
      countryKeywords: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.JobDateCreated,
    ifElseFirstColumnName: "Job Date created",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.JobDateUpdated,
    ifElseFirstColumnName: "Job Date updated",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
      { operatorId: 2, operatorName: AutomationTimeOperator.Before },
      { operatorId: 3, operatorName: AutomationTimeOperator.On },
      { operatorId: 4, operatorName: AutomationTimeOperator.After },
      { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
      { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 1,
      hours: 0,
      hideTimeCondition: true,
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateDocumentType,
    ifElseFirstColumnName: "Document Type",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.DoesNotExist
      },
    ],
    thirdColumn: {
      documentTypeOptions: [],
      documentType: "",
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateEmail,
    ifElseFirstColumnName: "Email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      emails: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateOtherEmail,
    ifElseFirstColumnName: "Secondary email",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Contains
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.NotContain
      },
    ],
    thirdColumn: {
      secondaryEmails: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidatePhone,
    ifElseFirstColumnName: "Phone",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateMobile,
    ifElseFirstColumnName: "Mobile",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsEmpty
      }
    ],
    thirdColumn: {}
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateContactMethod,
    ifElseFirstColumnName: "Contact method",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      contactMethods: [],
      names: ""
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateSeeking,
    ifElseFirstColumnName: "Seeking",
    operators: [
      {
        operatorId: 1,
        operatorName: AutomationTimeOperator.Is
      },
      {
        operatorId: 2,
        operatorName: AutomationTimeOperator.IsNot
      },
      {
        operatorId: 3,
        operatorName: AutomationTimeOperator.Exists
      },
      {
        operatorId: 4,
        operatorName: AutomationTimeOperator.IsEmpty
      },
    ],
    thirdColumn: {
      seekingStatuses: [],
      names: ""
    }
  },
  // ROI-368: operator ids and thirdColumn names copy the matching triggers (Availability,
  // Job application date, Resume date, Document Expiry Date). Unlike the triggers the time
  // block is always shown, starting at Any Date, so there is no hidden default window.
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateAvailability,
    ifElseFirstColumnName: "Availability",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.Before },
      { operatorId: 2, operatorName: AutomationTimeOperator.On },
      { operatorId: 3, operatorName: AutomationTimeOperator.After },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateJobApplicationDate,
    ifElseFirstColumnName: "Job application date",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.Is },
      { operatorId: 2, operatorName: AutomationTimeOperator.IsNot },
    ],
    thirdColumn: {
      options: [
        { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
        { operatorId: 2, operatorName: AutomationTimeOperator.LessThan },
        { operatorId: 3, operatorName: AutomationTimeOperator.MoreThan },
      ],
      jobIds: [],
      jobNames: "",
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      hideTimeCondition: false
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateResumeDate,
    ifElseFirstColumnName: "Resume date",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.MoreThan },
      { operatorId: 2, operatorName: AutomationTimeOperator.LessThan },
    ],
    thirdColumn: {
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0
    }
  },
  {
    ifElseFirstColumnId: AutomationIfElseFirstColumnType.CandidateDocumentExpiryDate,
    ifElseFirstColumnName: "Document expiry date",
    operators: [
      { operatorId: 1, operatorName: AutomationTimeOperator.Is },
      { operatorId: 2, operatorName: AutomationTimeOperator.IsNot },
      { operatorId: 3, operatorName: AutomationTimeOperator.IsEmpty },
      { operatorId: 4, operatorName: AutomationTimeOperator.Exists },
      { operatorId: 5, operatorName: AutomationTimeOperator.IsDateEmpty },
      { operatorId: 6, operatorName: AutomationTimeOperator.DateExists },
    ],
    thirdColumn: {
      options: [
        { operatorId: 1, operatorName: AutomationTimeOperator.AnyDate },
        { operatorId: 2, operatorName: AutomationTimeOperator.Before },
        { operatorId: 3, operatorName: AutomationTimeOperator.On },
        { operatorId: 4, operatorName: AutomationTimeOperator.After },
        { operatorId: 5, operatorName: AutomationTimeOperator.LessThan },
        { operatorId: 6, operatorName: AutomationTimeOperator.MoreThan },
      ],
      documentTypes: [],
      names: "",
      operatorId: 1,
      operatorName: AutomationTimeOperator.AnyDate,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      hideTimeCondition: false
    }
  }
];

export const UpdateRecordList = {
  Postcode: 1,
  CurrentWorkType: 2,
  Country: 3,
  Status: 4,
  AddNote: 5,
  ApplicationStatus: 8,
  CustomFields: 14,
  CandidateSkills: 15,
  Unsubscribe: 17,
  AddToJob: 19,
  UpdateRecruiter: 20,
  PlacementCustomFields: 21,
  ApplicationCustomFields: 22,
  JobCustomFields: 23,
  Rating: 24,
  City: 25,
  State: 26,
  PlacementStatus: 27,
  JobStatus: 28,
  CandidatePostalCode: 29,
  CandidateCountry: 30,
  ApplicationRating: 31,
}

// applyTo target for an UpdateRecruiter record update - null means "this candidate/contact"
export const UpdateRecordApplyToType = {
  Placements: 1,
  Jobs: 2,
  AllCandidatesInJob: 3,
  AllPlacementsInJob: 4,
}

export const UpdateRecruiterField = {
  Owner: 1,
  Recruiter: 2,
}

export const UpdateRecruiterMode = {
  Add: 1,
  Replace: 2,
}

export const UnsubscribeSubType = {
  Provider: 1,
  RoiAi: 2,
};

export const AutomationTriggerUnsubscribe = {
  triggerId: 0,
  customFieldTriggerId: 0,
  triggerName: "",
  operators: [
    { operatorId: 1, operatorName: "Yes" },
    { operatorId: 2, operatorName: "No" },
  ],
  thirdColumn: {}
};

export const JobAutomationUpdateRecordFirstColumn = [
  {
    id: UpdateRecordList.Status,
    name: "Status",
  },
  {
    id: UpdateRecordList.AddNote,
    name: "Add note",
  },
  {
    id: UpdateRecordList.ApplicationStatus,
    name: "Application status",
  },
  {
    id: UpdateRecordList.ApplicationRating,
    name: "Application rating",
  },
  {
    id: UpdateRecordList.CustomFields,
    name: "Candidate Custom Fields"
  },
  {
    id: UpdateRecordList.JobCustomFields,
    name: "Job Custom Fields"
  },
  {
    id: UpdateRecordList.ApplicationCustomFields,
    name: "Application Custom Fields"
  },
  {
    id: UpdateRecordList.CandidateSkills,
    name: "Skills"
  },
  {
    id: UpdateRecordList.Unsubscribe,
    name: "Unsubscribed",
  },
  {
    id: UpdateRecordList.AddToJob,
    name: "Add to Job"
  },
  {
    id: UpdateRecordList.Rating,
    name: "Rating"
  },
  {
    id: UpdateRecordList.JobStatus,
    name: "Job status"
  },
  {
    id: UpdateRecordList.City,
    name: "City"
  },
  {
    id: UpdateRecordList.State,
    name: "State"
  },
  {
    id: UpdateRecordList.CandidatePostalCode,
    name: "Postal code"
  },
  {
    id: UpdateRecordList.CandidateCountry,
    name: "Country"
  }
];
export const AutomationUpdateRecordFirstColumn = [
  {
    id: UpdateRecordList.Status,
    name: "Status",
  },
  {
    id: UpdateRecordList.AddNote,
    name: "Add note",
  },
  {
    id: UpdateRecordList.CustomFields,
    name: "Custom Fields"
  },
  {
    id: UpdateRecordList.CandidateSkills,
    name: "Skills"
  },
  {
    id: UpdateRecordList.Unsubscribe,
    name: "Unsubscribed",
  },
  {
    id: UpdateRecordList.AddToJob,
    name: "Add to Job"
  },
  {
    id: UpdateRecordList.Rating,
    name: "Rating"
  },
  {
    id: UpdateRecordList.City,
    name: "City"
  },
  {
    id: UpdateRecordList.State,
    name: "State"
  },
  {
    id: UpdateRecordList.CandidatePostalCode,
    name: "Postal code"
  },
  {
    id: UpdateRecordList.CandidateCountry,
    name: "Country"
  }
];

// Placement-based, candidate automations: Candidate, Placement, and Job custom fields are separate sections.
export const PlacementAutomationUpdateRecordFirstColumn = [
  {
    id: UpdateRecordList.Status,
    name: "Status",
  },
  {
    id: UpdateRecordList.AddNote,
    name: "Add note",
  },
  {
    id: UpdateRecordList.CustomFields,
    name: "Candidate Custom Fields"
  },
  {
    id: UpdateRecordList.PlacementCustomFields,
    name: "Placement Custom Fields"
  },
  {
    id: UpdateRecordList.JobCustomFields,
    name: "Job Custom Fields"
  },
  {
    id: UpdateRecordList.CandidateSkills,
    name: "Skills"
  },
  {
    id: UpdateRecordList.Unsubscribe,
    name: "Unsubscribed",
  },
  {
    id: UpdateRecordList.AddToJob,
    name: "Add to Job"
  },
  {
    id: UpdateRecordList.Rating,
    name: "Rating"
  },
  {
    id: UpdateRecordList.PlacementStatus,
    name: "Placement status"
  },
  {
    id: UpdateRecordList.ApplicationStatus,
    name: "Application status"
  },
  {
    id: UpdateRecordList.JobStatus,
    name: "Job status"
  },
  {
    id: UpdateRecordList.City,
    name: "City"
  },
  {
    id: UpdateRecordList.State,
    name: "State"
  },
  {
    id: UpdateRecordList.CandidatePostalCode,
    name: "Postal code"
  },
  {
    id: UpdateRecordList.CandidateCountry,
    name: "Country"
  }
];


export const AutomationClientUpdateRecordFirstColumn = [
  {
    id: UpdateRecordList.Status,
    name: "Status",
  },
  {
    id: UpdateRecordList.AddNote,
    name: "Note",
  },
  {
    id: UpdateRecordList.CustomFields,
    name: "Custom Fields"
  },
  {
    id: UpdateRecordList.CandidateSkills,
    name: "Skills"
  },
  {
    id: UpdateRecordList.Unsubscribe,
    name: "Unsubscribed",
  },
  {
    id: UpdateRecordList.PlacementStatus,
    name: "Placement status"
  },
  {
    id: UpdateRecordList.JobStatus,
    name: "Job status"
  }
];

// Job-based and Placement-based client automations: Contact Custom Fields keep the generic CustomFields
// value, while Job / Placement Custom Fields get their own entry so each is a separate picker section.
// The contact entry is renamed so it reads apart from those two (the base Contact list keeps "Custom Fields").
const ClientCustomFieldsNamedForEntityCampaigns = AutomationClientUpdateRecordFirstColumn.map(option =>
  option.id === UpdateRecordList.CustomFields ? { ...option, name: "Contact Custom Fields" } : option
);

export const JobAutomationClientUpdateRecordFirstColumn = [
  ...ClientCustomFieldsNamedForEntityCampaigns,
  {
    id: UpdateRecordList.JobCustomFields,
    name: "Job Custom Fields"
  }
];

export const PlacementAutomationClientUpdateRecordFirstColumn = [
  ...ClientCustomFieldsNamedForEntityCampaigns,
  {
    id: UpdateRecordList.PlacementCustomFields,
    name: "Placement Custom Fields"
  }
];

export const ListDaysShort = [
  {
    day: "Mon",
    value: "1"
  },
  {
    day: "Tue",
    value: "2"
  },
  {
    day: "Wed",
    value: "3"
  },
  {
    day: "Thu",
    value: "4"
  },
  {
    day: "Fri",
    value: "5"
  },
  {
    day: "Sat",
    value: "6"
  },
  {
    day: "Sun",
    value: "0"
  }
];

export const AutomationSpecificDays = {
  Monday: "1", Tuesday: "2", Wednesday: "3", Thursday: "4", Friday: "5", Saturday: "6", Sunday: "0"
};

export const AutomationOperator = [
  {
    id: 1,
    name: "AND"
  },
  {
    id: 2,
    name: "OR"
  },
];

export const AutomationStateType = {
  Active: 1,
  Inactive: 2,
  Ended: 3,
  Draft: 4,
  Deleted: 5,
  Underway: 6,
  EndedUnderway: 7,
};

export const SurveyStateType = {
  Active: 1,
  Inactive: 2
};

export const SurveyFormFace = {
  Autoscroll: "autoscroll",
  Chat: "chat",
  Classic: "classic"
};

export const OptionSalaryRate = [
  {
    value: "Hour",
    text: "Hourly Rate"
  },
  {
    value: "Day",
    text: "Daily Rate"
  },
  {
    value: "Week",
    text: "Weekly Rate"
  },
  {
    value: "Month",
    text: "Monthly Rate"
  },
  {
    // `text` is display-only (`value` is what's sent/stored); branch conditions
    // persist this label into the saved survey definition at pick time, so an
    // existing survey's branch on this option keeps showing the old label in
    // the builder until it's re-picked, even though the runner shows this text.
    value: "Year",
    text: "Annual Salary"
  },
];

// JobAdder's SubmitCandidateAvailabilityModel.Relative accepts a free-form
// Period (int) + a fixed Week/Month Unit — there's no lookup endpoint for
// this, so these presets mirror JobAdder's own candidate availability
// picker. Value encodes "{period}-{unit}" for BE-side parsing.
export const OptionNoticePeriod = [
  { value: "1-Week", text: "1 Week" },
  { value: "2-Week", text: "2 Weeks" },
  { value: "3-Week", text: "3 Weeks" },
  { value: "4-Week", text: "4 Weeks" },
  { value: "1-Month", text: "1 Month" },
  { value: "2-Month", text: "2 Months" },
  { value: "3-Month", text: "3 Months" },
  { value: "6-Month", text: "6 Months" },
];

export const AtsSyncVendor = {
  JobAdder: 1
}

export const AtsProvider = {
  JobAdder: "JobAdder",
  Bullhorn: "Bullhorn",
}

// Company.ProductType values. Free-text nvarchar(50) on the backend — these strings are written
// verbatim and compared by name (CustomerNotificationService.AinsteinProductType, the `product-type`
// JWT claim, the admin Plan filter, the RoiReporting export). Do not change existing spellings.
//
// Distinct from Company.IsAinsteinEnabled: ProductType "Ainstein" means an Ainstein-only tenant
// (created by self-serve signup with AtsProvider.None); IsAinsteinEnabled means a Roi-AI tenant
// that also has the Ainstein add-on.
export const ProductType = {
  RoiAi: "Roi-AI",
  RoiAiLite: "Roi-AI Lite",
  MarketingCloud: "Marketing Cloud",
  Ainstein: "Ainstein",
}

export const productTypeOptions = [
  { value: ProductType.RoiAi, label: "Roi-AI" },
  { value: ProductType.RoiAiLite, label: "Roi-AI Lite" },
  { value: ProductType.MarketingCloud, label: "Marketing Cloud" },
  { value: ProductType.Ainstein, label: "Ainstein" },
]

// Company.SalesType values. Free-text nvarchar on the backend like ProductType above — the stored
// string is the value, the label is display only. Do not change existing spellings.
export const SalesType = {
  JobAdderReseller: "JobAdderReseller",
  JobAdderPro: "JobAdderPro",
  Direct: "Direct",
  Internal: "Internal",
}

export const salesTypeOptions = [
  { value: SalesType.JobAdderReseller, label: "JobAdder Reseller" },
  { value: SalesType.JobAdderPro, label: "JobAdder Pro" },
  { value: SalesType.Direct, label: "Direct" },
  { value: SalesType.Internal, label: "Internal" },
]

// Resolve a stored value to its react-select option. Unrecognised values are preserved verbatim
// rather than dropped, so editing a company whose type the UI does not know about cannot silently
// reclassify it on save.
export const toSelectOption = (options, value) => {
  if (!value) return null;
  return options.find(option => option.value === value) ?? { value, label: value };
}

export const LimitMaxLength = {
  postalCode: 12,
  salary: 8
}

export const RangeNps = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
]

export const AudienceSource = {
  RoiAi: 1,
  ExternalProviders: 2
}

export const EmailReportType = {
  Processed: { typeId: 3, label: "Email Sent" },
  Bounced: { typeId: 4, label: "Email Bounced" },
  Opened: { typeId: 5, label: "Email Opened" },
  Delivered: { typeId: 6, label: "Email Delivered" },
  Unsubscribed: { typeId: 15, label: "Email Unsubscribed" },
  LinksClicked: { typeId: 17, label: "Link Clicked" },
  Invalid: { typeId: 23, label: "Invalid" },
  UnsubscribedList: { typeId: 27, label: "Previously Unsubscribed"},
  DuplicateEmail: { typeId: 28, label: "Duplicate Email" },
  Links: { typeId: 99, label: "Links" }
}

export const EmailReportCategory = {
  Candidate: 1,
  Client: 2
}

export const TextReportType = {
  Sent: { typeId: 7, label: "Text Sent" },
  Delivered: { typeId: 8, label: "Text Delivered" },
  Unsubscribed: { typeId: 16, label: "Text Unsubscribed" },
  LinksClicked: { typeId: 26, label: "Link Clicked" },
  Links: { typeId: 99, label: "Links" },
  Invalid: { typeId: 24, label: "Invalid" }
}

export const EmailReportChartBarIndex = {
  // these are the index of the chart bar (open rate [0], click rate[1], counce rate[2], unsubscribe rate[3]),,
  Opened: 0,
  LinksClicked: 1,
  Bounced: 2,
  Unsubscribed: 3,
}


export const SurveyReportType = {
  Opened: { typeId: 5, label: "Survey Opened" },
  Completion: { typeId: 99, label: "Survey Completion" } // typeID need ask Backend
}

export const SurveyReportChartBarIndex = {
  // these are the index of the chart bar (open rate [0], Completion rate[1]),,
  Opened: 0,
  Completion: 1,
}

export const TextReportChartBarIndex = {
  // these are the index of the chart bar (open rate [0], click rate[1], counce rate[2], unsubscribe rate[3]),,
  Delivered: 0,
  LinksClicked: 1,
  Unsubscribed: 2,
  Sent: 3
}

export const AutomationType = {
  Candidate: 1,
  Client: 2,
}

export const CustomFieldsType = {
  Candidate: "Candidate",
  Client: "Contact",
  Placement: "Placement",
  Job: "Job",
  Application: "Application",
}

export const AutomationTypeText = {
  Candidate: "Candidate",
  Contact: "Contact",
}

export const InvalidStatusText = {
  Subscribe: 'Subscribe',
  Unsubscribe: 'Unsubscribe'
}

// Matches backend Roi.Domain.Enums.Jobs.UserTaskRecordType (serialized as lowercase strings)
export const PrimaryRecordType = {
  Candidate: "candidate",
  Contact: "contact",
  Company: "company",
  Job: "job",
  Placement: "placement",
  Application: "application",
}

// Matches backend Roi.Domain.Enums.Jobs.UserTaskPriority
export const UserTaskPriority = {
  None: 0,
  Low: 1,
  Medium: 2,
  High: 3,
}

// Frontend-only toggle for the Task step's due date UI - not sent to the backend directly.
// The backend (UserTaskModel) infers relative vs. fixed from whether Months/Weeks/Days/Hours are set.
export const UserTaskDateMode = {
  Fixed: 1,
  Relative: 2,
}

export const SurveyCustomFieldType = {
  List: "List",
  Text: "Text",
  Date: "Date"
}

export const OwnerTypeCandidate = [
  { label: "Recruiter", value: 1 },
  { label: "Job owner", value: 2 },
  { label: "Admin user", value: 3 },
  { label: "No user", value: 4 },
  { label: "Placement recruiter", value: 5 }
]

export const OwnerTypeClient = [
  { label: "Contact owner", value: 1 },
  { label: "Job owner", value: 2 },
  { label: "Admin user", value: 3 },
  { label: "No user", value: 4 },
  { label: "Placement recruiter", value: 5 }
]

// Email step "sender" owner options only — adds the most-recent-note-owner sender,
// which is not supported by the Update Record / Task step owner pickers that reuse OwnerTypeCandidate/OwnerTypeClient.
export const EmailSenderOwnerTypeCandidate = [
  ...OwnerTypeCandidate,
  { label: "Most recent note owner", value: 7 }
]

export const EmailSenderOwnerTypeClient = [
  ...OwnerTypeClient,
  { label: "Most recent note owner", value: 7 }
]

export const UpdateRecordType = [
  { label: "Recruiter", value: 1 },
  { label: "Job owner", value: 2 },
  { label: "Admin user", value: 3 },
  { label: "No user", value: 4 },
  { label: "Placement recruiter", value: 5 }
]

export const UpdateRecordTypeClient = [
  { label: "Contact owner", value: 1 },
  { label: "Job owner", value: 2 },
  { label: "Admin user", value: 3 },
  { label: "No user", value: 4 },
  { label: "Placement recruiter", value: 5 }
]

export const UpdateRecordOwnerType = {
  Recruiter: 1,
  JobOwner: 2,
  AdminUser: 3,
  NoUser: 4,
  PlacementRecruiter: 5,
  DatabaseUser: 6,
  MostRecentNoteOwner: 7
}

export const UpdateRecordNoteType = {
  CandidateNote: 0,
  PlacementNote: 1,
  ApplicationNote: 2,
  JobNote: 3
}

export const OwnerAssignmentOptions = {
  RecentOwner: '1',
  Recruiter: '2'
}

export const EmailCategory = {
  Existing: 1,
  New: 2
};

export const EmailSource = {
  Scratch: 1,
  CopyExisting: 2,
  Template: 3,
  ViewEmail: 4,
};

export const EmailCategories = [
  {
    id: 1,
    name: "Use an existing email"
  },
  {
    id: 2,
    name: "Create new email"
  },
];

export const EmailSources = [
  {
    id: 1,
    name: "Start from scratch"
  },
  {
    id: 2,
    name: "Copy an existing email"
  },
  {
    id: 3,
    name: "Use a template"
  },
];

export const AtsFieldCategoryType = [
  {
    id: 0,
    name: "Candidate",
    displayName: "Candidate tags"
  },
  {
    id: 1,
    name: "CandidateRecruiter",
    displayName: "Candidate recruiter tags"
  },
  {
    id: 2,
    name: "Contact",
    displayName: "Contact tags"
  },
  {
    id: 3,
    name: "ContactOwner",
    displayName: "Contact owner tags"
  },
  {
    id: 4,
    name: "Placement",
    displayName: "Placement tags"
  },
  {
    id: 5,
    name: "Job",
    displayName: "Job tags"
  },
  {
    id: 6,
    name: "JobOwner",
    displayName: "Job owner tags"
  },
  {
    id: 7,
    name: "JobAd",
    displayName: "Job Ad tags"
  },
  {
    id: 8,
    name: "Token",
    displayName: "Token tags"
  },
  {
    id: 9,
    name: "Interview",
    displayName: "Interview tags"
  },
  {
    id: 10,
    name: "Other",
    displayName: "Other tags"
  },
  {
    id: 11,
    name: "Obselete",
    displayName: "Obselete tags"
  },
  {
    id: 12,
    name: "CustomField",
    displayName: "Custom field tags"
  },
  {
    id: 13,
    name: "Company",
    displayName: "Company tags"
  },
  {
    id: 14,
    name: "ContactRecruiter",
    displayName: "Contact recruiter tags"
  },
  {
    id: 15,
    name: "CompanyOwner",
    displayName: "Company owner tags"
  },
];

export const CandidateMergeTagsForContacts = [
  {
    "categoryType": "Candidate tags",
    "atsFields": [
      {
        "id": 2,
        "displayName": "Candidate First Name",
        "tokenVariable": "candidate_first_name",
        "atsFieldName": "candidateFirstName",
        "dataType": "string",
        "length": "50",
        "isShow": true,
        "isMandatory": true,
        "contactType": 1,
        "categoryType": 0
      },
      {
        "id": 3,
        "displayName": "Candidate Last Name",
        "tokenVariable": "candidate_last_name",
        "atsFieldName": "candidateLastName",
        "dataType": "string",
        "length": "50",
        "isShow": true,
        "isMandatory": true,
        "contactType": 1,
        "categoryType": 0
      }
    ]
  }
];

export const FolderCategory = {
  Add: 1,
  Remove: 2
};

export const FolderCategories = [
  {
    id: 1,
    name: "Add"
  },
  {
    id: 2,
    name: "Remove"
  }
];

export const UpdateFolderDestination = {
  CandidateContact: 1,
  Placement: 2,
  Application: 3
}

export const CustomFieldsAction = {
  Add: 1,
  Remove: 2
};

export const CustomFieldsActions = [
  {
    id: 1,
    name: "Add"
  },
  {
    id: 2,
    name: "Remove"
  }
];

export const CustomFieldDateMode = {
  EventDate: 1,
  SpecificDate: 2
};

export const CustomFieldDateModes = [
  {
    id: 1,
    name: "Event's date"
  },
  {
    id: 2,
    name: "Specific date"
  }
];

export const CandidateSkillsActions = [
  {
    id: 1,
    name: "Add"
  },
  {
    id: 2,
    name: "Remove"
  }
];
